<template>

    <question-base :required="answerRequired"
                   :next-button-text="translations.nextButtonText"
                   :back-button-text="translations.backButtonText"
                   :back-button-enabled="backButtonEnabled"
                   :skip-button-text="translations.skipButtonText"
                   @skip="skipClicked"
                   @next="nextClicked"
                   @back="backClicked"
                   :background-color="backgroundColor"
                   :button-color="buttonColor"
                   :saving="loading">

        <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

            <validation-provider
                    :name="variable.name"
                    :rules="rules"
                    mode="lazy"
                    v-slot="{ errors }">

                <question-header :question-text="questionText"
                                 :button-color="buttonColor"
                                 :background-color="backgroundColor"
                                 class="mb-5"
                ></question-header>

                <date-picker-field v-model="model"
                                   :label="questionText"
                                   :locale="locale.language_tag"
                                   :background-color="backgroundColor"
                                   :min="minDate"
                                   :max="maxDate"
                                   :start-with-year="true"
                                   :error-messages="errors"
                ></date-picker-field>

            </validation-provider>

            <json v-if="false" :data="variable"/>

        </validation-observer>
    </question-base>
</template>

<script>

    import questionMixin from "./questionMixin";
    import DatePickerField from "./DatePicker";
    import QuestionHeader from "./QuestionHeader";
    import QuestionBase from "./QuestionBase";
    import colorMixin from "./colorMixin";
    import {extend} from 'vee-validate/dist/vee-validate.full';
    import moment from 'moment';
    import {timeDisplay} from "../../mixins/timeDisplayMixin";
    import Json from "vue-json-pretty";

    export default {

        mixins: [questionMixin, colorMixin, timeDisplay],

        components: {
            DatePickerField,
            QuestionHeader,
            QuestionBase,
            Json
        },

        props: {
            value: {
                type: String | null,
                required: false,
            },

            componentData: {
                type: Object,
                required: false
            }
        },

        computed: {

            minDate() {
                if (this.rules.min_date) {
                    return this.rules.min_date;
                }

                if (this.variable.name === "BIRTH_DATE") {
                    return moment().subtract(100, 'years').format('YYYY-MM-DD');
                }
            },

            maxDate() {
                if (this.rules.max_date) {
                    return this.rules.max_date;
                }

                if (this.variable.name === "BIRTH_DATE") {
                    return moment().subtract(this.componentData.minAge, 'years').format('YYYY-MM-DD');
                }
            }
        },

        methods: {
            datePicked() {
                this.$emit('input', this.toUTCDate(this.model));
            }
        },

        created() {

            extend('min_date', {
                params: ['min_date'],
                validate: (value, {min_date}) => moment(value).isAfter(moment(min_date)),
                message: this.translations.survey_date_min,
                lazy: true
            });

            extend('max_date', {
                params: ['max_date'],
                validate: (value, args) => moment(value).isBefore(moment(args[0])),
                message: this.translations.survey_date_max,
                lazy: true
            });
        }

    }
</script>
